import styled from 'styled-components';
import { COLORS } from '../../../../theme';

export const StyledSelectionWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  .MuiButtonBase-root {
    margin-right: ${({ theme }) => theme.spacing.s4};
  }

  &:after {
    ${({ isHeader }) => isHeader && "content: '';"};
    width: ${({ theme }) => theme.spacing.s1};
    height: ${({ theme }) => theme.spacing.s1};
    border-radius: ${({ theme }) => theme.spacing.s1};
    background: ${COLORS.crayola};
    left: 28px;
    top: 0;
    position: absolute;
  }
`;
